/**
 * Bind event when mounted or activated
 */
import { on, off } from '../utils/dom/event';
export function BindEventMixin(handler) {
  function bind() {
    if (!this.binded) {
      handler.call(this, on, true);
      this.binded = true;
    }
  }

  function unbind() {
    if (this.binded) {
      handler.call(this, off, false);
      this.binded = false;
    }
  }

  return {
    mounted: bind,
    activated: bind,
    deactivated: unbind,
    beforeDestroy: unbind
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/mixins/bind-event.js
// module id = 5Fm4
// module chunks = 13